import React, { useEffect, useState } from "react";
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import ConfiguratorRoot from "../../examples/Configurator/ConfiguratorRoot";
import PropTypes from "prop-types";
import MDInput from "../../components/MDInput";
import MDButton from "../../components/MDButton";
import useApi from "../../components/Utils/api";
import toast from "utils/toast";
import { useMaterialUIController } from "../../context";
import {Controller} from "react-hook-form";
import MenuItem from "@mui/material/MenuItem";
import {FormControl, InputLabel, Select, InputAdornment} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import {generatePassword} from "../../utils/generatePassword";
import Refresh from "@mui/icons-material/Refresh";
import HistoryIcon from '@mui/icons-material/History';


function NewUser({openConfigurator, setOpenConfigurator}) {
  const [controller] = useMaterialUIController();
  const {user} = controller;  
    const [showPassword, setShowPassword] = useState(false);
  const [updatedUser, setUpdatedUser] = useState({
    firstName: '',
    lastName: '',
    mobileNo: '',
    passwd: '',
    emailId: '',
    dept: '',
    userId: '',
    countryCode: '91',
    role: ''
  });
  const api = useApi();
  const newUserFormHandler = (form) => {
    form.preventDefault();
    if(!isValidUserId) return;
    let updateUserReq = updatedUser;
    api.post("/users/create", updateUserReq)
      .then((response) => {
        if(response.data.statusCodeValue === 200){
          toast.success("User successfully added.");
          setOpenConfigurator(false);
          setUpdatedUser({
            firstName: '',
            lastName: '',
            mobileNo: '',
            emailId: '',
            dept: '',
            userId: '',
            countryCode: process.env.REACT_APP_COUNTRY_CODE,
            role: ''
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error("You do not have permission to perform this action.");
          return;
        }
        console.log(error.response)
        toast.error(error.response.data.body)
      })
    console.log(updateUserReq);
  }

  const isValidUserId = /^[A-Za-z0-9]{1,9}$/.test(updatedUser?.userId);

  return (
    <ConfiguratorRoot variant="permanent" ownerState={{ openConfigurator }} configuratorwidth={500}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        pt={4}
        pb={0.5}
        px={3}
      >
        <MDBox>
          <MDTypography variant="h5">New User</MDTypography>
          <MDTypography variant="body2" color="text">
            {updatedUser?.userId}
          </MDTypography>
        </MDBox>

        <Icon
          sx={({ typography: { size }, palette: { dark, white } }) => ({
            fontSize: `${size.lg} !important`,
            color: dark.main,
            stroke: "currentColor",
            strokeWidth: "2px",
            cursor: "pointer",
            transform: "translateY(5px)",
          })}
          onClick={() => setOpenConfigurator(false)}
        >
          close
        </Icon>
      </MDBox>
      <Divider />
      <MDBox component="form" role="form" onSubmit={(form) => newUserFormHandler(form)} style={{maxWidth: '480px'}}>
        <MDBox mb={2}>
          <MDInput type="text" label="Username" name="username" onChange={(e) => setUpdatedUser({ ...updatedUser, userId: e.target.value.toUpperCase() })} value={updatedUser?.userId} pattern="^[A-Za-z0-9]+$" title="Please enter alphanumeric characters only." success={isValidUserId} error={!isValidUserId} fullWidth required />
        </MDBox>
        <MDBox
          display="flex"
          justifyContent="space-between"
          mb={2}
        >
          <MDBox flex={1} boxSizing={'border-box'} mr={1}>
            <MDInput type="text" label="First Name" name="first_name" onChange={(e) => setUpdatedUser({ ...updatedUser, firstName: e.target.value })} value={updatedUser?.firstName} fullWidth required />
          </MDBox>
          <MDBox flex={1} boxSizing={'border-box'}>
            <MDInput type="text" label="Last Name" name="last_name" onChange={(e) => setUpdatedUser({ ...updatedUser, lastName: e.target.value })} value={updatedUser?.lastName} fullWidth required />
          </MDBox>
        </MDBox>
        <MDBox
          display="flex"
          justifyContent="space-between"
          mb={2}
        >
          <MDBox flex={4} boxSizing={'border-box'} mr={1}>
            <MDInput type="email" label="Email" name="email" onChange={(e) => setUpdatedUser({ ...updatedUser, emailId: e.target.value })} value={updatedUser?.emailId} fullWidth required />
          </MDBox>
          <MDBox flex={1} boxSizing={'border-box'}>
            <FormControl fullWidth style={{ height: '100%' }}>
              <InputLabel id="label-role">Select User Role</InputLabel>
              <Select
                  labelId="label-role"
                  id="label-role"
                  label="Select User Role"
                  fullWidth
                  style={{ height: '100%' }}
                  name="role"
                  onChange={(e) => setUpdatedUser({ ...updatedUser, role: e.target.value })}
                  value={updatedUser?.role}
              >
                <MenuItem value="">-Select user level-</MenuItem>
                <MenuItem value="MAKER">Admin</MenuItem>
                <MenuItem value="G_MAKER">Guest/Viewer</MenuItem>
              </Select>
            </FormControl>
            {/*<MDInput type="text" label="Role" name="role" value={user.role === "ADMIN" ? 'MAKER' : user.role === "SUPERADMIN" ? 'ADMIN' : ''} fullWidth disabled />*/}
          </MDBox>
        </MDBox>
        <MDBox
          display="flex"
          justifyContent="space-between"
          mb={2}
        >
      <MDInput
        type="tel"
        label="Mobile No"
        name="mobileNo"
        onChange={(e) => {
          const inputValue = e.target.value.slice(0, 10); // Limit to the first 10 characters
          setUpdatedUser({ ...updatedUser, mobileNo: inputValue });
        }}
        value={updatedUser?.mobileNo}
        fullWidth
        required
      />


          {/* <MDBox flex={1} boxSizing={'border-box'}>
            <MDInput type="text" label="Department" name="dept" onChange={(e) => setUpdatedUser({ ...updatedUser, dept: e.target.value })} value={updatedUser?.dept} fullWidth required />
          </MDBox> */}
        </MDBox>
        {/*<MDBox mb={2}>*/}
        {/*  <MDInput type="password" label="Password" name="passwd" onChange={(e) => setUpdatedUser({ ...updatedUser, passwd: e.target.value })} fullWidth required />*/}
        {/*</MDBox>*/}
        <MDBox mb={2}>
          <MDInput 
            type={showPassword ? 'text' : 'password'}
            label="Password" 
            name="passwd" 
            onChange={(e) => setUpdatedUser({ ...updatedUser, passwd: e.target.value })} 
            fullWidth 
            value={updatedUser?.passwd}
            required
            InputProps={{
                endAdornment: (
                    <>
                        {/* Button to toggle password visibility */}
                        <InputAdornment position="end">
                            <Tooltip title={showPassword ? 'Hide Password' : 'Show Password'}>
                                <IconButton onClick={() => setShowPassword((prev) => !prev)}>
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>

                        {/* Button to generate password */}
                        <InputAdornment position="end">
                            <Tooltip title="Generate Password">
                                <IconButton onClick={() => {
                                  let password = generatePassword(12, true);
                                  setUpdatedUser({ ...updatedUser, passwd: password });
                                }}>
                                    <Refresh />
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>
                    </>
                ),
            }}
          />
        </MDBox>

        <MDBox mt={4} mb={1}>
          <MDButton type="submit" variant="gradient" color="info" style={{float : 'right'}}>
            Add
          </MDButton>
        </MDBox>
      </MDBox>
    </ConfiguratorRoot>
  );
}

NewUser.defaultProps = {
  openConfigurator: false,
  setOpenConfigurator: false
}

NewUser.propTypes = {
  openConfigurator: PropTypes.bool,
  setOpenConfigurator: PropTypes.func
}

export default NewUser;